(function ( $ ) {
     $.fn.menuLink = function (options) {
        var objLink    = $(this);
        var head       = $('header');
        var nav        = $('header .nav');
        var opened     = false;
        var didScroll;
        var lastScrollTop = 0;
        var delta = 200;
      
        function _init() {
            $( objLink ).click(function() {
                if(nav.hasClass('close')){
                    $(this).addClass('open');
                    _openNavigation();
                }else{
                    $(this).removeClass('open');
                    _closeNavigation();
                }
            });

            _initScroll();
        }

        function hasScrolled() {
            scroll = $('main').offset().top-50;

            if($(this).scrollTop() > scroll){
                $('body').addClass('scrolled');
            }else{
                $('body').removeClass('scrolled');
            }
        }

        function _initScroll(){
            $(window).scroll(function(event){
                  didScroll = true;
            });

            setInterval(function() {
                 if (didScroll) {
                     hasScrolled();
                     didScroll = false;
                 }
             }, 1000);
        }

        function _closeNavigation(){
            objLink.removeClass('open');
            $(nav).addClass('close');
            $('body').removeClass('locked');
        }

        function _openNavigation(){
            objLink.addClass('open');

            $(nav).addClass('active').removeClass('close');
            $('body').addClass('locked');
        }

        _init();

       return {
         reload:_init,
       };
    };
}( jQuery ));

$(document).ready(function() {
    $(".jsLink").click(function(){
         window.location=$(this).find("a").attr("href");
         return false;
    });

    $("a.mobilNav").menuLink();

    video = $('#home').attr('data-video');
    if(video != '' && $( window ).width() > 600){
        str = '<video src="'+video+'" preload="true" autoplay="" loop="" muted=""></video>';
        $('#home').append(str);
    }
});
